"use client";
import { useContext, useEffect, useRef, useState } from "react";
import Banner from "../shared/Banner";
import ConstructionList from "./ConstructionList";
import { TBannerResponse } from "@/app/types/Shared/BannerAndShortVideo";
import useMediaGetter from "@/app/hooks/useMediaGetter";
import { TConstructionCard } from "@/app/types/constructionPageTypes";
import FiltrationComp from "../shared/FiltrationComp";
import Popup from "../shared/Popup/Popup";
import ConstructionDetails from "./ConstructionDetails";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import { loadingContext } from "@/app/store/context/isLoadingContext";
import gsap from "gsap";

const ConstructionUpdatesPageComponent = ({ banner, data }: { banner: TBannerResponse, data: TConstructionCard[] }) => {
    const {isIpad} = useContext(screenSizeContext)
    const { isPageFetched, setIsPageFetched } = useContext(loadingContext);

    const { imgSrc } = useMediaGetter(banner?.media)
    const [filteredData, setFilteredData] = useState<TConstructionCard[]>(data);
    useEffect(() => {
        setFilteredData(data)
        setTimeout(()=> {
            setIsPageFetched((prev: string)=> {
                if(prev === "loading") return "fetched";
                return prev;
            })
        })
    }, [data])

    const dateOptions = [
        {
            label: "Oldest",
            value: "oldest",
        },
        {
            label: "Latest",
            value: "latest",
        },
    ];

    const neighborOptions: any = [
        ...new Map(data.map((item: any) => [item.project_slug, { label: item.project_name, value: item.project_slug }])).values()
    ];

    const [selectedNeighbor, setSelectedNeighbor] = useState('');
    const [selectedDate, setSelectedDate] = useState('');

    useEffect(() => {
        let finalData: any[] = [...data];
        if (selectedDate == "latest") {
            finalData = finalData.sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime())

        } else {
            finalData = finalData.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime())
        }
        if (selectedNeighbor) {
            finalData = finalData.filter(item => item.project_slug == selectedNeighbor)
        }
        setFilteredData(finalData)
    }, [selectedDate, selectedNeighbor])

    const tl = useRef<GSAPTimeline>(gsap.timeline());
	useEffect(() => {
		if (isPageFetched === "fetched") {
			const timer = setTimeout(()=> {
				const html = document.documentElement;

				tl.current
				.timeScale(html.classList.contains("loaded") ? 1.25 : 1)
				.set(".banner .hero-title-word", { yPercent: 50, alpha: 0 })
				.set(".content_wrapper", { yPercent: 30 })
				.to(".banner .hero-image img", {
					delay: html.classList.contains("loaded") ? 0.4 : 2.2,
					duration: 1,
					ease: "power2.inOut",
					y: "0%"
				})
				.to(".banner .hero-image-wrapper", {
					duration: 1,
					ease: "power2.inOut",
					scale: 1,
				}, "-=0.25")
				.to(".navbar_section", {
					duration: 1,
					ease: "power2.inOut",
					y: "0%"
				}, "-=0.4")
				.to(".banner .hero-title-word", {
					duration: 1,
					stagger: 0.05,
					ease: "expo.inOut",
					yPercent: 0,
					alpha: 1
				}, "<")
				.to(".content_wrapper", {
					duration: 1,
					stagger: 0.05,
					ease: "expo.out",
					yPercent: 0,
				}, "<");
			}, 50);

			return () => clearTimeout(timer);
		}
	}, [isPageFetched]);
    
	const [activeModal, setActiveModal] = useState<boolean>(false)
    const [modalData, setModalData] = useState<TConstructionCard | null>(null)

    return (
        <div className={`page_wrapper ${isIpad && "construction-page"}`}>
            {imgSrc &&
                <Banner
                    priority
                    imageSrc={`${imgSrc}`}
                    title={banner?.title?.en}
                    minHeight="75vh"
                    mobileHeight="75vh"
                    noDescriptionWithSmallTitle
                    shortTitle
                />
            }
            <div className="px pb-0 py-12 lg:pb-20">
                <FiltrationComp
                    dateOptions={dateOptions}
                    neighborOptions={neighborOptions}
                    setSelectedDate={setSelectedDate}
                    setSelectedTab={setSelectedNeighbor}
                    placeholderText={"Neighborhood"}
                />
                <ConstructionList data={filteredData} setActiveModal={setActiveModal} setModalData={setModalData} />
            </div>
            <Popup
				customClassWrapper="popup_half bg-oSilver"
				setIsOpen={setActiveModal}
				isOpen={activeModal} 
                construction
			>
                <ConstructionDetails modalData={modalData}/> 
            </Popup>
        </div>
    );
}

export default ConstructionUpdatesPageComponent;